import { useWalletModal } from './WalletModalContext';
import '../styles/Hero.css';

export default function Hero({ zIndex }) {
  const { open } = useWalletModal();

  return (
    <section className="hero" style={{ zIndex }}>
      <video
        className="hero__bg"
        autoPlay
        muted
        loop
        playsInline
        aria-hidden="true"
      >
        <source src="/images/hero-bg.webm" type="video/mp4" />
      </video>

      <div className="hero__content">
        <h1 className="hero__heading">
          
          <span className="hero__line hero__line--semibold">DOPPLER RESOLVE</span>
        
        </h1>
        <p>Having trouble with your DOPPLER tokens, $XDP claim, Migration, Staking, Bridging or Wallet Issues? Our support portal helps you diagnose and fix every issue fast.</p>
        <div className="hero__actions">

          <div className="hero__wallet-row">
            <button type="button" className="hero__wallet-btn" onClick={open}>
              Connect Wallet
            </button>

            <button type="button" className="hero__wallet-btn hero__wallet-btn--outline" onClick={open}>
              Claim
            </button>
          </div>
        </div>
      </div>

      <div className="hero__latest">
        <div className="hero__latest-left">
          <span className="hero__latest-label">Latest Posts</span>
          <a
            href="https://blog.doppler.finance/blog/introducing-xdp"
            target="_blank"
            rel="noreferrer"
            className="hero__latest-title"
          >
            Introducing XDP
          </a>
        </div>
        <a
          href="https://blog.doppler.finance/"
          target="_blank"
          rel="noreferrer"
          className="hero__latest-more"
        >
          View More <span>↗</span>
        </a>
      </div>
    </section>
  );
}